// extracted by mini-css-extract-plugin
export default {"container":"OrderPopupStatus_container__1hbJX"};